import { render } from "./viewReportPdf.vue?vue&type=template&id=259ec719&scoped=true"
import script from "./viewReportPdf.vue?vue&type=script&lang=js"
export * from "./viewReportPdf.vue?vue&type=script&lang=js"

import "./viewReportPdf.vue?vue&type=style&index=0&id=259ec719&lang=less&scoped=scoped"

import exportComponent from "E:\\claude_code\\healthmall\\tongue_desktop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-259ec719"]])

export default __exports__